export class PasswordGenerationRequest {
  public userId: number = 0;
  public passwordCharacterLength: number = 12;
  public numberOfNonAlphaNumericCharacters: number = 2;
  public newUser: boolean = false;
}